export default __webpack_public_path__ + "static/en_klein-49310ac4179a9af5edfe2d26c2567995.png";